import React from "react";
import {Box, Text} from "@reside/ui";
import {AdminLayoutFullHeightAndTwoCells} from "../../../atoms/admin-layout";
import {useCreateResident} from "../hooks/useCreateResident";
import {DocumentTitle} from "../../../atoms/document-title";
import {ResidentFormik} from "../atoms/ResidentFormik";
import {BackdropSpinner} from "../../../atoms/spinner";

export const PageAdminResidentsCreate = (): JSX.Element => {
  const {mutate: createResident, isLoading: isCreating} = useCreateResident();

  return (
    <AdminLayoutFullHeightAndTwoCells>
      <BackdropSpinner active={isCreating}>
        <Box position="relative">
          <DocumentTitle title="Reside - Admin - New Resident" />

          <Text fontSize="24px" fontWeight="bold">
            New Resident
          </Text>

          <ResidentFormik
            initialValues={{
              first_name: "",
              middle_name: "",
              last_name: "",
              date_of_birth: "",
              gender: "",
              organization_id: null,
              status: "NEW",
            }}
            handleSubmit={createResident}
          />
        </Box>
      </BackdropSpinner>
    </AdminLayoutFullHeightAndTwoCells>
  );
};
